import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faClipboardList,
  faPlusSquare,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import Modal from '../../../../components/Modal';
import { useDashboardContext } from '../../context';
import PropTypes from 'prop-types';
import Spinner from 'react-bootstrap/Spinner';
import CustomToast from '../../../../components/Toast';

const SelectRecipientModal = ({
  assignmentId,
  assignments,
  title,
  saveButton,
  addRemoveListHeader,
  addByLabel,
  manageButton,
  dataArray,
  setDataArray,
  resetGridData,
  resetSelectedAssignment,
  loader,
  setLoader,
  flashcards,
  isModalOpen
}) => {
  const {
    selectRecipient,
    setSelectRecipient,
    setSendEmailModal,
    setSlectedStudents,
    setIntialAddingSelectedStudents,
    slectedStudents,
    intialAddingSelectedStudents,
    setManageDist,
    manageDis,
    intialRomovingSelectedStudents,
    setIntialRomovingSelectedStudents,
    createDist,
    setCreateDist,
    searchValue,
    setSearchValue,
    loadAllMessageGroup,
    getAllAssignmentShareUsers,
    setAllAssignmentShareUsers,
    setShareAssignments,
    isReplayMessage,
    setShareActivities
  } = useDashboardContext();

  const [apiIsProcessing, setApiIsProcessing] = useState(false);
 
  useEffect(() => {
    loadAllMessageGroup();
  }, []);

  const selectRecipientCancelHandler = () => {
    setSearchValue('');
    setSelectRecipient(false);
    setSendEmailModal(!isReplayMessage);
    setSlectedStudents(slectedStudents.filter(x=>!x.newStudent));
    setIntialAddingSelectedStudents(() => []);
    if (assignments || flashcards) {
      setSearchValue('');
      setDataArray([]);
    }
    isModalOpen?.(false);
  };

  const handleSelectStudentsCheckboxChange = (student) => {
    setIntialAddingSelectedStudents((prevSelectedStudents) => {
      if (prevSelectedStudents.includes(student)) {
        return prevSelectedStudents.filter((s) => s !== student);
      } else {
        return [...prevSelectedStudents, student];
      }
    });
  };
  
  const selectstudentHandler = () => {
    const uniqueStudents = intialAddingSelectedStudents.filter((student) => {
      return !slectedStudents.some(
        (selectedStudent) => selectedStudent.studentId === student.studentId
      );
    });
    const uniqueData = [...new Map(uniqueStudents.map((item) => [item.studentId, item])).values()].map(item => ({ ...item, newStudent: true }));
    console.log(uniqueData);
    if (uniqueData.length === 0) {
      // Handle duplicate case here
      console.log('All selected students already exist in the list!');
    } else {
      // Add unique students to selectedStudents array
      setSlectedStudents((prevState) => [...prevState, ...uniqueData]);
    }
    setIntialAddingSelectedStudents(() => []);
  };

  const manageditHandler = () => {
    setSelectRecipient(!selectRecipient);
    setManageDist(!manageDis);
  };

  const removeSelectedStudentsHandler = () => {
    setSlectedStudents((prevSelectedStudents) => {
      return prevSelectedStudents.filter((s) => !intialRomovingSelectedStudents.includes(s));
    });
    setIntialRomovingSelectedStudents(() => []);
    CustomToast('Removed Successfully', 'success');
  };

  const createDistributionHandler = () => {
    setCreateDist(!createDist);
  };

  const selectRecipientSaveHandler = async () => {
    setSearchValue('');
    if (assignments) {
      setApiIsProcessing(true);
      await setShareAssignments(assignmentId);
      setSlectedStudents(() => []);
      setIntialAddingSelectedStudents(() => []);
      setSearchValue('');
      resetSelectedAssignment([]);
      resetGridData(new Date().getSeconds());
      setDataArray([]);
      setSelectRecipient(false);
      setApiIsProcessing(false);
      isModalOpen?.(false);
    } else if(flashcards){
      setApiIsProcessing(true);
      await setShareActivities(assignmentId);
      setSlectedStudents(() => []);
      setIntialAddingSelectedStudents(() => []);
      setSearchValue('');
      resetSelectedAssignment([]);
      resetGridData(new Date().getSeconds());
      setDataArray([]);
      setSelectRecipient(false);
      setApiIsProcessing(false);
      isModalOpen?.(false);
    } else if (isReplayMessage) {
      setSelectRecipient(false);
      setSendEmailModal(false);
    } else {
      setSelectRecipient(false);
      setSendEmailModal(true);
    }
  };

  const selectRemoveStudentHandler = (student) => {
    setIntialRomovingSelectedStudents((prevSelectedStudents) => {
      if (prevSelectedStudents.includes(student)) {
        return prevSelectedStudents.filter((s) => s !== student);
      } else {
        return [...prevSelectedStudents, student];
      }
    });
  };

  const removeSingleStudentHandler = (student) => {
    setSlectedStudents((prevSelectedStudents) => {
      return prevSelectedStudents.filter((s) => s !== student);
    });
    setIntialRomovingSelectedStudents((prevSelectedStudents) => {
      return prevSelectedStudents.filter((s) => s !== student);
    });
    CustomToast('Removed Sucessfully', 'success');
  };

  const searchHandler = (e) => {
    setSearchValue(e.target.value);
    if (assignments || flashcards) {
      if (e.target.value.length >= 3) {
        setLoader(true);
        getAllAssignmentShareUsers(e.target.value);
      } else {
        setAllAssignmentShareUsers([]);
      }
    } else {
      setSearchValue(e.target.value);
    }
  };
  return (
    <Modal
      isOpen={selectRecipient}
      titleName={title}
      onClose={selectRecipientCancelHandler}
      contentWidth="100%">
      <div className="row">
        <div className="col-lg-6">
          <div className="recipient-box">
            <p>
              Enter either a login id or user&apos;s name (Last, First), then select from dropdown
              and press add.
            </p>
            <div className="custom-search position-relative mb-3">
              <FontAwesomeIcon icon={faSearch} />
              <input
                type="text"
                value={searchValue}
                onChange={(e) => searchHandler(e)}
                placeholder=""
                className="form-control"
              />
            </div>

            {loader ? (
              <>
                <div className="d-flex justify-content-center">
                  <div className="d-flex align-items-center gap-3 mx-auto opacity-50">
                    <Spinner animation="border" role="status" />
                    <span>Load More...</span>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="student-listing-modal overflow-auto mb-3">
                  {dataArray
                    .filter(
                      (student) =>
                        student.fName.toLowerCase().includes(searchValue.toLowerCase()) ||
                        student.lName.toLowerCase().includes(searchValue.toLowerCase()) ||
                        student.login.toLowerCase().includes(searchValue.toLowerCase()) ||
                        `${student.lName} ${student.fName}`
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                    )
                    .map((student, index) => (
                      <div
                        key={index}
                        className="form-check-data d-flex justify-content-between align-items-center mb-3">
                        <label className="form-check-label ms-3" htmlFor="Optionsc">
                          {student.lName + ' ' + student.fName} {student.email && `(${student.email})`} {student.schoolName && `(${student.schoolName})`}
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id={`Optionsc-${index}`}
                          onChange={() => handleSelectStudentsCheckboxChange(student)}
                          checked={intialAddingSelectedStudents.includes(student)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                    ))}
                </div>
              </>
            )}
            <div className="col-12 d-flex justify-content-end">
              <button onClick={selectstudentHandler} className="btn btn-castleWhite">
                Add
              </button>
            </div>

            <div className="col-12 d-flex justify-content-between mt-3 pt-3 distribution-list">
              {addByLabel}:
              <button onClick={manageditHandler} className="btn-link secondary-link">
                <FontAwesomeIcon className="me-2" icon={faClipboardList} /> {manageButton}
              </button>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="recipient-box-2 h-100 d-flex flex-column">
            <h4 className="secondary-title">{addRemoveListHeader}</h4>
            <div className="selected-student-listing-modal overflow-auto mb-3">
              {slectedStudents?.map((student, index) => (
                <div
                  key={index}
                  className="form-check d-flex align-items-center mb-3"
                  style={{ justifyContent: 'space-between' }}>
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      onChange={() => selectRemoveStudentHandler(student)}
                      id={`Optionsc${index}`}
                      checked={intialRomovingSelectedStudents.includes(student)}
                    />
                    <label className="form-check-label ms-3">
                      {student.lName + ' ' + student.fName}
                    </label>
                  </div>
                  <div>
                    <button
                      onClick={() => removeSingleStudentHandler(student)}
                      className="btn btn-castleWhite">
                      <FontAwesomeIcon className="me-2" icon={faTrash} /> Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="col-12 d-flex justify-content-end mt-auto">
              <button
                onClick={removeSelectedStudentsHandler}
                className={
                  intialRomovingSelectedStudents.length && slectedStudents.length > 0
                    ? 'btn btn-castleWhite'
                    : 'btn btn-castleWhite disable-Pointer-Events disabled'
                }>
                Remove Selected
              </button>
            </div>

            {!assignments && slectedStudents.length > 0 && (
              <div
                onClick={createDistributionHandler}
                className="col-12 d-flex justify-content-end mt-3 pt-3 distribution-list">
                <button className="btn-link secondary-link">
                  <FontAwesomeIcon className="me-2" icon={faPlusSquare} /> Create Distribution List
                  From Names
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="col-12 d-flex justify-content-end mt-3">
          <button onClick={selectRecipientCancelHandler} className="btn btn-castleGray me-2">
            Cancel
          </button>
          <button
            onClick={selectRecipientSaveHandler}
            disabled={apiIsProcessing || !slectedStudents || slectedStudents.length==0}
            className='btn btn-castleRed'
          >
            {saveButton}
          </button>
        </div>
      </div>
    </Modal>
  );
};

SelectRecipientModal.propTypes = {
  assignmentId: PropTypes.array,
  assignments: PropTypes.bool,
  title: PropTypes.string.isRequired,
  saveButton: PropTypes.string.isRequired,
  addRemoveListHeader: PropTypes.string.isRequired,
  addByLabel: PropTypes.string.isRequired,
  manageButton: PropTypes.string.isRequired,
  dataArray: PropTypes.array.isRequired,
  resetGridData: PropTypes.func,
  resetSelectedAssignment: PropTypes.func,
  setDataArray: PropTypes.func,
  loader: PropTypes.bool,
  setLoader: PropTypes.func,
  flashcards: PropTypes.bool,
  isModalOpen: PropTypes.func
};
export default SelectRecipientModal;
